export * as Api from './api';
export var SignatureType;
(function (SignatureType) {
    SignatureType["PlainText"] = "PLAIN_TEXT";
})(SignatureType || (SignatureType = {}));
//# sourceMappingURL=index.js.map